import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Section1.css';
import client4 from '../images/food4.jpg';
import newoutput from '../images/food1.jpg';
import free from '../images/free.jpg';
import newoutput3 from '../images/food5.jpg';

const Section1 = () => {
  return (
    <Carousel fade interval={2000}>
      <Carousel.Item>
        <div className="carousel-image-wrapper">
          <img src={free} alt="Welcome Offer" className="carousel-image" />
          <div className="carousel-overlay"></div>
          <div className="carousel-text">
            <h2>A Feast for Your Senses</h2>
            <p>Discover the art of fine dining with our curated menu.</p>
          </div>
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="carousel-image-wrapper">
          <img src={newoutput} alt="Delicious Dishes" className="carousel-image" />
          <div className="carousel-overlay"></div>
          <div className="carousel-text">
            <h2>Fresh. Flavorful. Fantastic.</h2>
            <p>From farm to plate, savor the freshest ingredients.</p>
          </div>
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="carousel-image-wrapper">
          <img src={newoutput3} alt="Signature Meals" className="carousel-image" />
          <div className="carousel-overlay"></div>
          <div className="carousel-text">
            <h2>Where Taste Meets Tradition</h2>
            <p>Indulge in our chef's specially curated recipes.</p>
          </div>
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="carousel-image-wrapper">
          <img src={client4} alt="Exquisite Dining" className="carousel-image" />
          <div className="carousel-overlay"></div>
          <div className="carousel-text">
            <h2>Every Bite, A Celebration</h2>
            <p>Where every bite is a celebration of taste.</p>
          </div>
        </div>
      </Carousel.Item>
    </Carousel>
  );
};

export default Section1;
